import * as React from "react";
const SvgFiRrCustomizeEdit = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-customize-edit_svg__a)">
      <path
        fill="#062147"
        d="M10.288 11.067c1.755-.338 3.542.88 3.7 2.66A3 3 0 0 1 11 17H7a1.005 1.005 0 0 1-.961-1.307c.499-1.608 1.936-4.18 4.249-4.626M20 12a1 1 0 0 0-1 1v6c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3V8c0-1.654 1.346-3 3-3h7a1 1 0 1 0 0-2H5C2.243 3 0 5.243 0 8v11c0 2.757 2.243 5 5 5h11c2.757 0 5-2.243 5-5v-6a1 1 0 0 0-1-1M23.139.863a2.943 2.943 0 0 0-4.162-.002c-.039.04-6.728 7.28-6.728 7.28-.452.506-.263 1.29.357 1.565l.021.01a.97.97 0 0 0 1.119-.249l6.611-7.157a.945.945 0 0 1 1.334-.074l.038.036a.943.943 0 0 1 .001 1.334l-.001.001-6.879 6.686a.985.985 0 0 0-.112 1.254.98.98 0 0 0 1.522.162l6.878-6.685a2.947 2.947 0 0 0 0-4.163z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-customize-edit_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCustomizeEdit;
